import React from "react";
import TopicFrame from "../../../components/TopicFrame/TopicFrame";

const SigaPage = () => {
  return (
    <>
      <TopicFrame topicType="signalTheorie" entryNumber={6}>
        
      </TopicFrame>
    </>
  );
};

export default SigaPage;
